import{a as r}from"./chunk-2HA4XQFN.js";var o=r(e=>Number(e.toPrecision(12)),"fixNumber");export{o as a};
